/** Organisation-level, so not store-scoped. */
export const organizationSettingsKeys = {
  all: ['org', 'settings'] as const,
  profile: ['org', 'profile'] as const,
};
